import { BinIcon } from "../../../../components/icon/Icon";
import {
    CardMiniatureBackgroundStyled,
    CardMiniatureContainerStyled,
    CardMiniatureHeadStyled,
    CardMiniatureInfoRowStyled,
    CardMiniatureInfoStyled
} from "./styled/CardMiniatureStyled";

export const CardMiniature = ({ color, bgColor, headColor, fontSize, style }) => (
    <CardMiniatureContainerStyled color={color} fontSize={fontSize} style={style}>
        <CardMiniatureBackgroundStyled bgColor={bgColor}/>
        <CardMiniatureHeadStyled color={color} headColor={headColor}>
            <BinIcon name="IcPerson"/>
        </CardMiniatureHeadStyled>
        <CardMiniatureInfoStyled>
            <CardMiniatureInfoRowStyled color={color} style={{ height: '2.7em', marginBottom: '2.4em' }} />
            <CardMiniatureInfoRowStyled color={color} style={{ height: '1.8em', marginBottom: '1.2em' }} />
            <CardMiniatureInfoRowStyled color={color} style={{ height: '1.8em', width: '6em' }} />
        </CardMiniatureInfoStyled>
    </CardMiniatureContainerStyled>
);